import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import { EditFormMenu } from './EditFormMenu.jsx';
import { NewFormMenu } from './NewFormMenu.jsx';
import { PreviewFormMenu } from './PreviewFormMenu.jsx';
import { CampaignPreviewFormMenu } from './CampaignPreviewFormMenu.jsx';

export const TileActionMenu = ({
  onClose,
  onDiscard,
  uuid = '',
  currentPage,
  publishDate,
  goToEdit,
  goToPreview,
  tileStatus,
  postId,
  campaignContainer,
  autoSaved,
}) => {
  return (
    <Menu>
      {uuid && currentPage === 'edit' && (
        <EditFormMenu
          goToPreview={goToPreview}
          campaignContainer={campaignContainer}
          postId={postId}
          tileStatus={tileStatus}
          publishDate={publishDate}
          onClose={onClose}
          uuid={uuid}
          autoSaved={autoSaved}
        />
      )}

      {!uuid && currentPage === 'edit' && (
        <NewFormMenu
          onClose={onClose}
          onDiscard={onDiscard}
          autoSaved={autoSaved}
        />
      )}

      {currentPage === 'tile-view' && (
        <PreviewFormMenu
          goToEdit={goToEdit}
          campaignContainer={campaignContainer}
          postId={postId}
          tileStatus={tileStatus}
          publishDate={publishDate}
          onClose={onClose}
          uuid={uuid}
        />
      )}

      {currentPage === 'campaign-preview' && (
        <CampaignPreviewFormMenu
          campaignContainer={campaignContainer}
          postId={postId}
          tileStatus={tileStatus}
          publishDate={publishDate}
          onClose={onClose}
          uuid={uuid}
        />
      )}
    </Menu>
  );
};

const Menu = styled.div`
  background: ${themeGet('colors.background')};
  margin: 0 10px;
  padding: 10px 0;
  position: sticky;
  align-items: center;
  top: 0;
  z-index: 3;
  width: ${props => props.width};
  border-bottom: 1px solid ${themeGet('colors.black.10')};
  display: grid;
  grid-template-areas: 'close auto-save title . switch-mode';
  grid-template-columns: 164px 1fr 500px 1fr 164px;
`;
